module.exports = __webpack_public_path__ + "img/40200.1c65f7f7.jpg";